export const netsuiteSubrecords = {
  shippingaddress: 'Shipping Address'
};
